/**
 * Icons —— 图标异步加载组件 (静态工具类版)
 *
 * 自动从 /public/icons.svg 加载非首屏图标并注入到指定的 defs 容器中。
 * 现已调整为主要使用外部引用，不再向 DOM 注入全量 symbol。
 */
export class Icons {
  private static isFetching = false;
  private static cachedSvgText: string | null = null;
  private static readonly INITIALIZED_ATTR = "data-icons-initialized";

  /**
   * 执行加载逻辑
   */
  private static async load(container: HTMLElement): Promise<void> {
    // 1. 防止对同一个元素重复初始化
    if (container.hasAttribute(Icons.INITIALIZED_ATTR)) return;

    // 2. 检查当前容器内部是否已存在异步图标（兜底检查）
    if (container.querySelector("#icon-github")) {
      container.setAttribute(Icons.INITIALIZED_ATTR, "true");
      return;
    }

    // 3. 如果有缓存的内容，直接注入
    if (Icons.cachedSvgText) {
      Icons.inject(Icons.cachedSvgText, container);
      return;
    }

    // 4. 如果正在抓取，跳过（由 compiler 触发的下一个周期会自动命中缓存或重新进入）
    if (Icons.isFetching) return;

    Icons.isFetching = true;
    try {
      const response = await fetch("/public/icons.svg");
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);

      Icons.cachedSvgText = await response.text();
      Icons.inject(Icons.cachedSvgText, container);
    } catch (error) {
      console.error("[Icons] 异步加载图标失败:", error);
    } finally {
      Icons.isFetching = false;
    }
  }

  /**
   * 将 SVG 内容注入 DOM (已废弃全量注入，仅保留接口兼容)
   */
  private static inject(_svgText: string, container: HTMLElement): void {
    // 方案调整：改用外部 SVG Sprite 引用，不再向 DOM 注入全量图标。
    // 这可以显著减小 DOM 大小并提升性能。
    container.setAttribute(Icons.INITIALIZED_ATTR, "true");
    console.log(`[Icons] 已切换为外部 Sprite 引用，跳过 DOM 注入`);
  }

  /**
   * 注册 Unpoly 编译器
   */
  static compiler(selector: string = "#icon-svg-defs"): void {
    // 1. 针对具体容器的编译器
    up.compiler(selector, (element: Element) => {
      Icons.load(element as HTMLElement);
    });

    // 2. 监听全局片段更新
    up.on("fragment:inserted", () => {
      const element = document.querySelector(selector);
      if (element) {
        Icons.load(element as HTMLElement);
      }
    });
  }
}
